import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { fmtDate } from "@/lib/format";

export const DIALOG_CLS = "w-[calc(100%-2rem)] max-h-[90vh] overflow-y-auto rounded-xl";

export function ConfirmDialog({ open, onOpenChange, title, description, onConfirm, testId }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[calc(100%-2rem)] rounded-xl" data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancelar</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testId}-confirm`} onClick={onConfirm}>Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function NoteDialog({ open, onOpenChange, title, label, confirmLabel, onConfirm, testId }) {
  const [note, setNote] = useState("");
  const submit = () => {
    if (!note.trim()) return toast.error("Descreva o motivo.");
    onConfirm(note.trim());
    setNote("");
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={DIALOG_CLS} data-testid={testId}>
        <DialogHeader><DialogTitle className="font-display text-xl">{title}</DialogTitle></DialogHeader>
        <p className="text-sm text-neutral-500">{label}</p>
        <Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} data-testid={`${testId}-input`} />
        <Button onClick={submit} className="w-full font-semibold" data-testid={`${testId}-confirm`}>{confirmLabel}</Button>
      </DialogContent>
    </Dialog>
  );
}

export function HistoryDialog({ open, onOpenChange, title, history = [], testId }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={DIALOG_CLS} data-testid={testId}>
        <DialogHeader><DialogTitle className="font-display text-xl">Histórico</DialogTitle></DialogHeader>
        <p className="-mt-2 text-sm text-neutral-500">{title}</p>
        {!history.length && <p className="text-sm text-neutral-400">Nenhuma alteração registrada.</p>}
        <ol className="space-y-3 border-l border-gold/40 pl-5">
          {[...history].reverse().map((h, i) => (
            <li key={`${history.length - 1 - i}-${h.date}`} className="text-sm" data-testid={`${testId}-entry-${i}`}>
              <p className="font-medium text-neutral-800">{h.text}</p>
              <p className="text-xs text-neutral-500">{h.by} · {fmtDate(h.date)}</p>
            </li>
          ))}
        </ol>
      </DialogContent>
    </Dialog>
  );
}
